export default "__VITE_ASSET__BMIyPYk5__"